import { merge } from "lodash";
import { IVariaveisAmbiente, IAmbienteUnico } from "./types";

const AmbienteEnviado = (process.env.REACT_APP_ENV || "prodWeb") as keyof IVariaveisAmbiente;
const AmbientePadrao: keyof IVariaveisAmbiente = AmbienteEnviado;
const LabelEnviado = (process.env.REACT_APP_LABEL || "Touchone") as keyof IVariaveisAmbiente;

const apiUrl = 'https://api-boletos-gateway-prod.touchone.com.br';
const apiImagemUrl = 'https://api-imagens.saurus.net.br';

const apiHomologacao = 'https://api-boletos-gateway-prod.touchone.com.br'

const apiVersao = 'v1'

export const sistemaId = 'bd2d7c0c-1383-444f-8ddb-70047aade745'

export const chaveDemonstracao = 'ZDhkMDlmYmUtNjU0Yi00YzMyLTk3NmEtMGFmZGZjZTFiMGEzfDk5OTk5OTk5MDAwMTkx'

const _variaveisAmbiente: IVariaveisAmbiente = {
  all: {
    version: "1.0.1",
    googleAppId: "27279191635-5kdincvmbm92lihatr0k4tm1o4kon8ue.apps.googleusercontent.com",
    saurusUtilsWebService: "https://wsmaster.saurus.net.br/v004/serviceMaster.asmx",
    label: LabelEnviado,
    environment: AmbienteEnviado,
    isDev: (["prodWeb"]
      .find(x => x === AmbientePadrao.toString())?.length || 0) === 0,
    apiVersion: apiVersao
  },
  devWeb: {
    apiUrl: apiHomologacao,
    apiImagemUrl: apiImagemUrl,
    facebookAppId: "661218711269424",
    frontUrl: "https://app.touchone.com.br",
    googleMapsKey: 'AIzaSyAHel2Psd44GXntYN5ufrKDjg7aGLoectY'
  },
  prodWeb: {
    apiUrl: apiUrl,
    apiImagemUrl: apiImagemUrl,
    facebookAppId: "1880946222051906",
    frontUrl: "https://app.touchone.com.br",
    googleMapsKey: 'AIzaSyAHel2Psd44GXntYN5ufrKDjg7aGLoectY'
  },
};

const _ambienteUnico =
  (_variaveisAmbiente[AmbientePadrao] as IAmbienteUnico) || _variaveisAmbiente.devWeb;
export const VariaveisAmbiente = merge(_variaveisAmbiente.all, _ambienteUnico);
